import React from 'react'

import { ListSubheader, Typography } from '@material-ui/core'

interface IFocusDropdownTitleProps {
  actions?: React.ReactNode
  children?: React.ReactNode
}

const FocusDropdownTitle = ({ children }: IFocusDropdownTitleProps) => {
  return (
    <ListSubheader
      component={Typography}
      variant="subtitle2"
      disableSticky
    >
      {children}
    </ListSubheader>
  )
}

export default FocusDropdownTitle
